module.exports = __webpack_public_path__ + "img/ride-for-good.db94866b.png";